import { InvestorAccountModel } from '@common/models/InvestorAccountModel';
import { SelfAccreditationClaims } from '@common/models/InvestorAccountModel/types';
import create from 'zustand';

interface VerifyAccreditationViewModelInterface {
  handleForm: (claims: SelfAccreditationClaims) => Promise<{ error?: string; success: boolean }>;
  page: 'verify' | 'success';
  setPage: (page: 'verify' | 'success') => void;
}
export const useVerifyAccreditationViewModel = create<VerifyAccreditationViewModelInterface>((set) => ({
  handleForm: async (claims: SelfAccreditationClaims) => {
    const { updateAccreditationInformation } = InvestorAccountModel.getState();
    const result = await updateAccreditationInformation(claims);
    return result;
  },
  page: 'verify',
  setPage: (page: 'verify' | 'success') => set({ page }),
}));
